import React, {useEffect, useState } from 'react';
import {
    DataGrid,
    GridToolbarContainer,
    ruRU,
} from "@material-ui/data-grid";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";


import DescriptionIcon from "@material-ui/icons/Description";

import {makeStyles} from "@material-ui/styles";
import {GridCellExpand} from "../GridCellExpand/GridCellExpand.jsx";
import {Statuses} from "../../utils/actStatuses";
import {downloadActFile, downloadActWordFile, downloadActExcelFile, downloadActScanFile} from "../../redux/reducers/act-reducer";
import {DynamicFields} from "../../utils/dynamicFields";

import { getActTemplateField } from "../../redux/reducers/act-template-reducer";
import { useSelector } from "react-redux";
import { Tooltip, Typography } from '@material-ui/core';

import { DynamicFieldComponent } from '../DynamicFieldComponent/DynamicFieldComponent.jsx';
import { ValiationTextField } from '../DynamicFieldComponent/inputs/TextField/TextField.jsx';
const useStyles = makeStyles(theme => (
        {
            redCircle: {
                width: 8,
                height: 8,
                marginRight: theme.spacing(1),
                borderRadius: '50%',
                backgroundColor: '#EC0C0C'
            },
            greenCircle: {
                width: 8,
                height: 8,
                marginRight: theme.spacing(1),
                borderRadius: '50%',
                backgroundColor: '#0CEC22'
            },
            violetCircle: {
                width: 8,
                height: 8,
                marginRight: theme.spacing(1),
                borderRadius: '50%',
                backgroundColor: '#8B00FF'
            },
            yellowCircle: {
                width: 8,
                height: 8,
                marginRight: theme.spacing(1),
                borderRadius: '50%',
                backgroundColor: '#ECC80C'
            },
            blueCircle: {
                width: 8,
                height: 8,
                marginRight: theme.spacing(1),
                borderRadius: '50%',
                backgroundColor: '#0067d9'
            },
            blackCircle: {
                width: 8,
                height: 8,
                marginRight: theme.spacing(1),
                borderRadius: '50%',
                backgroundColor: '#000000'
            },
            hidden: {
                display: 'none'
            },
            root: {
                '& .MuiDataGrid-columnsContainer': {
                    borderBottom: '2px solid #000000'
                },
            },
            textVialation: {
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 3, // Ограничение до 3 строк
                overflow: "hidden",
                textOverflow: "ellipsis", // Добавляет "..." в конце
                wordBreak: "break-word", // Перенос длинных слов
                lineHeight: "1.3em", // Высота строки
            }
        }
    )
)


const CustomToolbar = ({value, onChange}) => {
    return <GridToolbarContainer>
        <Grid container direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
            {/* <Grid item> */}
                {/* <GridToolbarFilterButton/> */}
                {/* <GridToolbarDensitySelector/> */}
            {/* </Grid> */}
            <Grid item xs container alignItems={'center'} justifyContent={'flex-end'}>
                {/* <Grid item>
                    <TextField
                        variant="standard"
                        value={value}
                        onChange={onChange}
                        placeholder="Поиск…"
                        InputProps={{
                            startAdornment: <SearchIcon fontSize="small"/>
                        }}
                    />
                </Grid> */}
            </Grid>

        </Grid>
    </GridToolbarContainer>
}

export const RenderActDocumentCell = (params) => {
    const handleWordClick = (actId) => async () => {
        await downloadActWordFile(actId)
    }
    const handleExcelClick = (actId) => async () => {
        await downloadActExcelFile(actId)
    }

    if (!params.row.status ||
        params.row.status === Statuses.IN_WORK_STATUS ||
        params.row.status === Statuses.DELETED_STATUS
    ) {
        return '—'
    }
    return (
        <div>
            <IconButton onClick={handleWordClick(params.value.actId)}>
        <DescriptionIcon stroke='#1826a1' htmlColor='green'/>
    </IconButton>
    <IconButton onClick={handleExcelClick(params.value.actId)}>
        <DescriptionIcon stroke='green' htmlColor='green'/>
    </IconButton>
        </div>

    )
}

export const RenderActDocumentContractors = (params) => {
    const handleClick = (actId) => async () => {
        await downloadActFile(actId)
    }
    return <IconButton onClick={handleClick(params.row.id)}>
        <DescriptionIcon/>
    </IconButton>
}

export const RenderActScanCell = (params) => {
    const handleClick = (files) => async () => {
        await Promise.all(files.map(file => downloadActScanFile(file)))
    }
    if (!params?.value || params?.value?.length === 0) {
        return '—'
    }
    return <IconButton onClick={handleClick(params.value)}>
        <DescriptionIcon/>
    </IconButton>
}


export const RenderStatusCell = (params) => {
    const classes = useStyles()
    let circleClass
    let text

    switch (params.value) {
        case Statuses.IN_WORK_STATUS:
            circleClass = classes.blueCircle
            text = 'В/Р'
            break
        case Statuses.DELETED_STATUS:
            circleClass = classes.blackCircle
            text = 'Уд'
            break
        case Statuses.APPROVED_STATUS:
            circleClass = classes.violetCircle
            text = 'Утв'
            break
        case Statuses.FOR_APPROVAL_STATUS:
            circleClass = classes.yellowCircle
            text = 'На/Ут'
            break
        case Statuses.REJECTED_STATUS:
            circleClass = classes.redCircle
            text = 'Откл'
            break
        case Statuses.STATUS_SIGNED:
            circleClass = classes.greenCircle
            text = 'Подп'
            break
        default:
            circleClass = classes.hidden
            text = '—'
            break
    }
    return <>
        <div className={circleClass}/>
        {text}
    </>
}


export const RenderViolationsCell = (params) => {

    if (params?.value?.length === 0) {
        return '—'
    }
    return (
        
        <GridCellExpand
            value={params?.value ? params.value.toString() : ''}
            width={params?.colDef?.computedWidth}
        />
    )
}



export const RenderOffestViolationCell = (params) => {

    if (params?.value?.length === 0) {
        return '—'
    }
    return (
        <Tooltip key={params.id} title={params?.formattedValue ? params.formattedValue.toString() : ''} placement="top" classes={{ tooltip: { maxWidth: '500px'} }}>
            <Typography
                style={{
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.3em",
                    maxHeight: "3.9em",
                    overflow: "hidden",
                }}
                key={`${params.id}-typography`}
            >
                {params?.formattedValue ? params.formattedValue.toString() : ''}
            </Typography> 
        </Tooltip>
    )
}

export const GetField = ({
    type,
    fields,
    formik,
    contentField
}) => {
    contentField.helperText = '';
    contentField.label = '';

    if (type === DynamicFields.TEXT_FIELD) {
        return <ValiationTextField 
            {...contentField}
            {...formik.getFieldProps(contentField.variable)}
            touched={formik.touched[contentField.variable]}
            error={formik.errors[contentField.variable]}
            setFieldValue={formik.setFieldValue}
        />
    }

    return <DynamicFieldComponent 
                type={type} 
                {...contentField}
                {...formik.getFieldProps(contentField.variable)}
                touched={formik.touched[contentField.variable]}
                error={formik.errors[contentField.variable]}
                setFieldValue={formik.setFieldValue}  
            />
}

export const FocusTyporgphy = ({
    type,
    isEdit,
    fields,
    formik,
    contentField,
}) => {


    if (isEdit) {
        return <GetField type={type} fields={fields} formik={formik} contentField={contentField} />
    }

    const date = type === DynamicFields.DATE_TIME_SELECT && new Date(contentField.value);
    const stringDate = date.toLocaleString('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Moscow'
      })

    return (
        <div>
            <Typography
                style={{
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.3em",
                    maxHeight: "3.9em",
                    overflow: "hidden",
                }}
            >
                {type === DynamicFields.DATE_TIME_SELECT ? stringDate : contentField.value ? contentField.value : ''}
            </Typography> 
        </div>

    )
}

export const RenderVTable = (params, typeField, isEdit, fields, formik) => {
    const allFields = useSelector(getActTemplateField)
    const field = params?.field;
    const value = params?.formattedValue ?? params?.value

    const offenseList = allFields.filter(({ type }) => type === DynamicFields.SELECTED_OFFENSE_LIST)[0];
    const contentField = offenseList?.content.offenseWindow.filter(({ variable }) => variable === field )[0];
    contentField.value = value;

    return <FocusTyporgphy type={typeField} isEdit={isEdit} fields={fields} formik={formik} contentField={contentField} />
}


export const ActTable = ({rows, columns, loading, onRowDoubleClick}) => {
    const classes = useStyles()

    const [searchText, setSearchText] = useState('')
    const [currentRows, setCurrentRows] = useState(rows)


    const escapeRegExp = (value) => {
        return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
    }

    const requestSearch = (searchValue) => {
        setSearchText(searchValue)
        const searchRegex = new RegExp(escapeRegExp(searchValue), 'i')
        const filteredRows = rows.filter((row) => {
            return Object.keys(row).some((field) => {
                return searchRegex.test(row[field].toString())
            })
        })
        setCurrentRows(filteredRows)
    }

    useEffect(() => {
        setCurrentRows(rows)
    }, [rows])

    return <div style={{height: '100%', width: '100%'}}>
        <DataGrid rows={currentRows}
                  columns={columns}
                  components={{Toolbar: CustomToolbar}}
                  componentsProps={{
                      toolbar: {
                          value: searchText,
                          onChange: (event) => requestSearch(event.target.value),
                      },
                  }}
                  density={'compact'}
                  onRowDoubleClick={onRowDoubleClick}
                  localeText={ruRU?.props?.MuiDataGrid?.localeText || ruRU?.components?.MuiDataGrid?.defaultProps?.localeText}
                  disableSelectionOnClick
                  loading={loading}
                  classes={{root: classes.root}}
                  disableColumnMenu
                  fullWidth
        />
        
    </div>
}